import type { Apis } from '@sparrow-marketing/contracts';

import { axios } from './axios';
import { endpoints } from '../constants';

export type Body = Omit<Apis.ReportsApi.IExportReport, 'url'>;
type Response = Apis.ReportsApi.IExportReport;

export default {
  async post(body: Body) {
    const { exportReportUrl } = endpoints();

    try {
      const { data } = await axios.post<Response>(`${exportReportUrl}`, body);
      return data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
};
